import React, {createContext, ReactNode, useContext, useState} from 'react';
import {AlertTypeProps} from '../types';
import Alert from "../components/Alert";


interface AlertProviderProps {
    children: ReactNode;
}

export const AlertContext = createContext<any>({});

export const AlertProvider: React.FC<AlertProviderProps> = ({children}) => {
    const [alertMessage, setAlertMessage] = useState<string>("")
    const [alertType, setAlertType] = useState<AlertTypeProps>(AlertTypeProps.INFO)

    const showSuccessAlert = (message: string, duration: number = 5000) => {
        setAlertMessage(message)
        setAlertType(AlertTypeProps.SUCCESS)

        setTimeout(() => {
            setAlertMessage("")
        }, duration)
    }
    const showErrorAlert = (message: string, duration: number = 5000) => {
        setAlertMessage(message)
        setAlertType(AlertTypeProps.ERROR)

        setTimeout(() => {
            setAlertMessage("")
        }, duration)
    }
    const showInfoAlert = (message: string, duration: number = 5000) => {
        setAlertMessage(message)
        setAlertType(AlertTypeProps.INFO)

        setTimeout(() => {
            setAlertMessage("")
        }, duration)
    }
    const showWarningAlert = (message: string, duration: number = 5000) => {
        setAlertMessage(message)
        setAlertType(AlertTypeProps.WARNING)

        setTimeout(() => {
            setAlertMessage("")
        }, duration)
    }

    return (
        <AlertContext.Provider value={{showSuccessAlert, showErrorAlert, showInfoAlert, showWarningAlert}}>
            {children}
            {alertMessage && <Alert alertType={alertType} alertMessage={alertMessage}/>}
        </AlertContext.Provider>
    );
};


export const useAlert = () => {
    const context = useContext(AlertContext);
    if (context === undefined) {
        throw new Error('useAlert must be used within a AlertProvider');
    }
    return context;
};
